export default (state = [], action) => {
  switch (action.type) {
    case "SET_CURRENT_OCCUPANCIES":
      const current_occupancies = action.payload.occupancies.filter((occupancy) =>
        occupancy.moved_out_at === null || moment(occupancy.moved_out_at).isAfter(moment())
      );
      return current_occupancies || [];
    default:
      return state;
  }
}
